import { Modal } from "@tokenterminal/core/ui/overlays/modal/Modal"
import { Suspense, lazy } from "react"
import type { PaywallContentProps } from "./AuthPaywallContent"

export type LazyAuthPaywallModalProps = PaywallContentProps & {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const AuthPaywallContent = lazy(() =>
  import("./AuthPaywallContent").then((module) => ({
    default: module.AuthPaywallContent,
  }))
)

export function LazyAuthPaywallModal({
  featureText,
  onClose,
  isOpen,
  setIsOpen,
}: LazyAuthPaywallModalProps) {
  return (
    <Modal size="auto" isOpen={isOpen} onOpenChange={setIsOpen}>
      <Suspense fallback={null}>
        <AuthPaywallContent onClose={onClose} featureText={featureText} />
      </Suspense>
    </Modal>
  )
}
